import { useState } from 'react';

interface ScreenshotPreviewProps {
  url?: string;
  thumbnailMode?: boolean;
}

export function ScreenshotPreview({ url, thumbnailMode = false }: ScreenshotPreviewProps) {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  if (!url) {
    return (
      <div className="flex items-center justify-center h-32 bg-dark-700 rounded border border-dark-600 text-dark-200 text-sm">
        No screenshot available
      </div>
    );
  }

  return (
    <div className={`relative bg-dark-700 rounded border border-dark-600 overflow-hidden ${thumbnailMode ? 'h-24' : 'h-96'}`}>
      {loading && (
        <div className="absolute inset-0 flex items-center justify-center bg-dark-700">
          <div className="text-sm text-dark-200">Loading...</div>
        </div>
      )}
      {error ? (
        <div className="absolute inset-0 flex items-center justify-center bg-dark-700 text-accent-red text-sm">
          Failed to load screenshot
        </div>
      ) : (
        <img
          src={url}
          alt="Screenshot"
          className="w-full h-full object-cover"
          onLoad={() => setLoading(false)}
          onError={() => {
            setLoading(false);
            setError(true);
          }}
        />
      )}
    </div>
  );
}
